<template>
  <b-card>
    <section-menu
      :name-module="nameModule"
      :sections-in-tab="sectionsInTab"
    />
    <b-row class="pt-1">
      <b-col>
        <router-view />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import SectionMenu from '@/views/partials/menu/SectionMenu.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    SectionMenu,
  },

  data() {
    return {
      sectionsInTab: [
        { id: 1, route: 'ac-general-info', name: 'accountSettings.generalInfo' },
        { id: 2, route: 'ac-address-and-contact', name: 'accountSettings.addressAndContact' },
        { id: 3, route: 'ac-change-password', name: 'accountSettings.changePassword' },
      ],
      nameModule: 'generic.profile',
    }
  },

  mounted() {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(this.$route.params.id)) {
      this.$router.replace({ name: 'error-404' })
    }
  },
}
</script>
